export function getScrollbarSize() {
  // Creating invisible container
  const outer = document.createElement('div')
  outer.style.visibility = 'hidden'
  outer.style.overflow = 'scroll' // forcing scrollbar to appear
  outer.style.msOverflowStyle = 'scrollbar' // needed for WinJS apps
  document.body.appendChild(outer)

  // Creating inner element and placing it in the container
  const inner = document.createElement('div')
  outer.appendChild(inner)

  // Calculating difference between container's full width and the child width
  const width = (outer.offsetWidth - inner.offsetWidth)
  const height = (outer.offsetHeight - inner.offsetHeight)

  // Removing temporary elements from the DOM
  outer.parentNode.removeChild(outer)

  return { width, height }
}